// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"_3Cn0-yuE","label":"_3sF75tRj","dollarSign":"_3iJ3vpMQ","input":"_1TO8OTqx"};